<template>
  <div class="password-expired-container">
    <div class="p-16 border border-solid rounded-zt-md bg-white shadow">
      <div class="password-expired-company-logo w-3/4 mx-auto">
        <img :src="logoURL" alt="Tu Recibo" />
      </div>
      <div class="mx-auto my-12">
        <zt-alert
          :text="alertMessage"
          :color="errorPassword ? 'danger' : 'primary'"
          :closeIcon="false"
          data-vs-alert="alert-pass-expired"
        >
          <div slot="icon">
            <div
              class="rounded-full w-24 h-24 flex justify-center items-center border-2 border-zt-primary-200"
              :class="{
                'border-zt-danger': errorPassword,
                'bg-zt-danger': errorPassword,
              }"
            >
              <zt-icon
                v-if="errorPassword"
                class="text-5xl ml-px text-zt-white"
                name="shield-asterisk"
              />
              <zt-icon
                v-else
                class="text-5xl mb-1"
                name="exclamation-triangle"
              />
            </div>
          </div>
        </zt-alert>
      </div>
      <div class="mx-auto mb-8 ">
        <zt-tooltip
          position="right"
          :clickable="true"
          color="dark-300"
          outlined
          :shadow="true"
        >
          <div slot="body" class="p-3">
            <PasswordPolicie :pass-policies="passPolicies" />
          </div>
          <zt-input
            class="mb-1"
            v-model="password"
            label="Contraseña"
            outlined
            v-validate="{ required: true, min: 8, regex: /^.*[0-9]{1,}.*$/ }"
            name="password"
            type="password"
            maxlength="32"
            :color="!passwordIsValid ? 'danger' : 'primary'"
            data-vs-input="input-pass-expired-pass"
        /></zt-tooltip>
        <div
          class="ml-4 text-xs text-zt-danger"
          v-show="errors.items[0] && errors.items[0].rule === 'required'"
        >
          {{ $t("message.passwordExpired.password_validation.required") }}
        </div>
        <div
          class="ml-4 text-xs text-zt-danger"
          v-show="errors.items[0] && errors.items[0].rule === 'min'"
        >
          {{
            $t("message.passwordExpired.password_validation.min_character_rule")
          }}
        </div>
        <div
          class="ml-4 text-xs text-zt-danger"
          v-show="errors.items[0] && errors.items[0].rule === 'regex'"
        >
          {{
            $t("message.passwordExpired.password_validation.min_number_rule")
          }}
        </div>
        <div class="ml-4 text-xs">
          {{
            $t("message.passwordExpired.password_validation.min_character_info")
          }}
        </div>
      </div>
      <div class="mx-auto mb-12 h-20">
        <zt-input
          class="mb-1"
          v-model="confirmPassword"
          label="Repetir contraseña"
          outlined
          type="password"
          :color="password !== confirmPassword ? 'danger' : 'primary'"
          maxlength="32"
          data-vs-input="input-pass-expired-confirm-pass"
        />
        <span
          v-show="password !== confirmPassword && confirmPassword !== ''"
          class="ml-4 text-xs text-zt-danger"
          >{{
            $t("message.passwordExpired.password_validation.no_match_pass")
          }}</span
        >
        <div class="ml-4 text-xs">
          {{
            $t("message.passwordExpired.password_validation.min_character_info")
          }}
        </div>
      </div>
      <div class="flex justify-content-end items-center">
        <span @click="backToLogin" class="mr-4 cursor-pointer">{{
          $t("message.passwordExpired.go_back_btn")
        }}</span>
        <zt-button
          :disabled="
            password !== confirmPassword || password === '' || !passwordIsValid
          "
          class="py-4 px-5"
          @click="changePasswordExpired"
          data-vs-button="button-pass-expired-submit-change-pass"
          >{{ $t("message.passwordExpired.update_pass_btn") }}</zt-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import User from "@/apiClient/User";
import PasswordPolicie from "@/components/generics/PasswordPolicie.vue";

export default {
  name: "PasswordExpired",
  components: {
    PasswordPolicie
  },
  props: {
    lastPassword: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      user: "",
      passPolicies: {},
      password: "",
      confirmPassword: "",
      errorPassword: false,
      codeErrorPassword: "",
      logoURL: `${window.sichern.cdnURL}/media/login/Login-Logo.png`
    };
  },

  computed: {
    passwordIsValid() {
      if (
        (this.errors.items[0] && this.errors.items[0].rule === "required") ||
        (this.errors.items[0] && this.errors.items[0].rule === "min") ||
        (this.errors.items[0] && this.errors.items[0].rule === "regex")
      ) {
        return false;
      }
      return true;
    },
    alertMessage() {
      let msg = this.$t("message.passwordExpired.pass_expired_message");

      if (this.codeErrorPassword !== "") {
        msg = this.$t(
          `message.passwordExpired.message_error.error_${this.codeErrorPassword}`
        );
      }
      return msg;
    },
    inputPass() {
      let input = document.getElementById("input-password");
      return input;
    },
  },
  methods: {
    backToLogin() {
      this.$emit("backToLogin");
    },
    async changePasswordExpired() {
      this.errorPassword = false;
      this.codeErrorPassword = "";
      try {
        let response = await this.user.changePassV2(
          this.lastPassword,
          this.password,
          this.confirmPassword
        );
        if (response.status === 200) {
          this.$emit("passSuccess");
        }
      } catch (error) {
        if (error.response) {
          this.codeErrorPassword = error.response.data.codes[0].code;
          this.errorPassword = true;
        }
      }
    },
    async getPassPolicies() {
      try {
        const { data } = await this.user.passwordPoliciesV2();
        this.passPolicies = data;
      } catch (error) {}
    },
  },
  mounted() {
    this.user = new User();

    this.getPassPolicies();
  },
};
</script>

<style lang="scss" scoped>
</style>
